/* fitlibrary-promo.js — promotional ticker motion.

   WHY JS OWNS THIS AND NOT @keyframes. The strip used to drift with a CSS
   transform animation. Every remote measurement said it ran — name, duration,
   play-state, a live non-identity matrix, 210px of travel per 2s — yet it was
   never visible in the merchant's real browser. Headless Chromium has NO GPU,
   so it cannot reproduce compositing faults, which is the one class of bug
   that gives exactly that symptom: a promoted layer whose transform advances
   while its painted content is a cached snapshot. Rather than keep guessing
   which ingredient triggered it (sticky ancestor, backdrop-filter root, clip),
   motion now comes from a per-frame style write, which no layer-caching quirk
   can silently swallow.

   ONE TRANSFORM OWNER. The keyframes are gone from fitlibrary-promo.css; this
   file is the only thing that writes .fl-promo__track's transform. With JS
   off the strip sits still and stays readable — the intended fallback.

   Time-based, not frame-based: pixels-per-second x real elapsed time, so
   60/120/144Hz all travel at the same rate and a dropped frame never
   shortens the journey. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var live = [];

  /* Retire controllers whose element the Theme Editor has replaced, so a
     section reload can never leave an orphan loop running on a detached node. */
  function sweep() {
    for (var i = live.length - 1; i >= 0; i--) {
      if (!document.contains(live[i].el)) { live[i].destroy(); live.splice(i, 1); }
    }
  }

  function create(track) {
    var groups = track.querySelectorAll('.fl-promo__group');
    if (groups.length < 2) return null;

    var raf = 0, last = 0, offset = 0, groupW = 0, pps = 62, dead = false, rt = 0;

    /* Speed and geometry both come from the live layout, never hardcoded:
       --fl-promo-pps is declared in the stylesheet so tuning stays in CSS,
       and one group's measured width is the exact wrap distance. */
    function measure() {
      var w = groups[0].getBoundingClientRect().width;
      groupW = (isFinite(w) && w > 0) ? w : 0;
      var v = parseFloat(getComputedStyle(track).getPropertyValue('--fl-promo-pps'));
      pps = (isFinite(v) && v > 0) ? v : 62;
      if (groupW > 0) { offset = offset % groupW; if (offset > 0) { offset -= groupW; } }
    }

    function paint() { track.style.transform = 'translateX(' + offset.toFixed(2) + 'px)'; }
    function clear() { track.style.transform = ''; }

    function frame(ts) {
      if (dead) { return; }
      if (!last) { last = ts; }
      var dt = (ts - last) / 1000;
      last = ts;
      if (dt > 0.25) { dt = 0.25; }
      /* LEFT -> RIGHT: offset climbs from -groupW toward 0, so copy enters at
         the left edge and travels right. Wrapping by exactly one group width
         between two identical groups makes the reset invisible. */
      offset += pps * dt;
      if (groupW > 0) { while (offset >= 0) { offset -= groupW; } }
      paint();
      raf = window.requestAnimationFrame(frame);
    }

    function play() {
      if (dead || raf || reduce.matches || document.hidden || groupW <= 0) { return; }
      last = 0;
      raf = window.requestAnimationFrame(frame);
    }
    function pause() {
      if (raf) { window.cancelAnimationFrame(raf); }
      raf = 0; last = 0;
    }

    function onResize() {
      window.clearTimeout(rt);
      rt = window.setTimeout(function () { measure(); if (!reduce.matches) { paint(); } }, 150);
    }
    function onVis() { if (document.hidden) { pause(); } else { play(); } }
    function onReduce() {
      if (reduce.matches) { pause(); clear(); }
      else { measure(); offset = -groupW; paint(); play(); }
    }

    window.addEventListener('resize', onResize);
    document.addEventListener('visibilitychange', onVis);
    if (reduce.addEventListener) { reduce.addEventListener('change', onReduce); }
    else if (reduce.addListener) { reduce.addListener(onReduce); }

    measure();
    if (reduce.matches) { clear(); }
    else { offset = -groupW; paint(); play(); }

    /* Inter arrives after first paint and changes the group's width, so the
       wrap distance is re-measured once the webfont has settled. */
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(function () { if (!dead) { measure(); if (!reduce.matches) { paint(); } } });
    }

    return {
      el: track,
      destroy: function () {
        dead = true; pause(); window.clearTimeout(rt);
        window.removeEventListener('resize', onResize);
        document.removeEventListener('visibilitychange', onVis);
        if (reduce.removeEventListener) { reduce.removeEventListener('change', onReduce); }
        else if (reduce.removeListener) { reduce.removeListener(onReduce); }
      }
    };
  }

  /* Idempotent: the dataset flag stops a second loop attaching to a track that
     already has one, however many times the editor re-runs this. */
  function init(root) {
    sweep();
    var scope = root && root.querySelectorAll ? root : document;
    var tracks = scope.querySelectorAll('.fl-promo__track');
    for (var i = 0; i < tracks.length; i++) {
      if (tracks[i].dataset.flTicker === 'on') { continue; }
      var c = create(tracks[i]);
      if (c) { tracks[i].dataset.flTicker = 'on'; live.push(c); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', sweep);
})();
